import {
  SDKReplacementTags,
  Sdk,
  SdkBaseAddonModel,
  SdkFlowPageModel,
  SdkPopoverModel,
  SdkSectionModel
} from '@playable-marketing/campaign-sdk';
import { AddonTypes } from '../../types/sdk';

export const Addons: AddonTypes = {
  GAME: 'gameplay'
};

export function getSdk(): Promise<Sdk> {
  if (!window.sdk) {
    return new Promise<Sdk>((resolve) => {
      window.addEventListener('lf-sdk-ready', async () => {
        if (window.sdk) {
          resolve(window.sdk);
        }
      });
    });
  }

  return Promise.resolve(window.sdk);
}

export function* addonIterator(
  pageModel: SdkFlowPageModel | SdkPopoverModel | SdkSectionModel
): Generator<SdkBaseAddonModel> {
  for (const row of pageModel.rows) {
    for (const column of row.columns) {
      for (const addon of column.addons) {
        yield addon;
      }
    }
  }
}

export function hasAddon(alias: string, pageModel: SdkFlowPageModel | SdkPopoverModel | SdkSectionModel): boolean {
  for (const addon of addonIterator(pageModel)) {
    if (addon.alias === alias) {
      return true;
    }
  }

  return false;
}

export function getAddon(
  alias: string,
  pageModel: SdkFlowPageModel | SdkPopoverModel | SdkSectionModel
): SdkBaseAddonModel | undefined {
  for (const addon of addonIterator(pageModel)) {
    if (addon.alias === alias) {
      return addon;
    }
  }

  return undefined;
}

export function getGameType(): Promise<string | undefined> {
  return new Promise<string | undefined>(async (resolve) => {
    const sdk = await getSdk();
    const gameType = await sdk.campaign.getType();

    resolve(gameType);
  });
}

export function getReplacementTag(name: string, replacementTags: SDKReplacementTags[]): string {
  return replacementTags.find((replacementTag) => replacementTag.name === name)?.value || '';
}

export function addBodyClass(name: string) {
  getSdk().then((sdk) => {
    if (!sdk.utils.hasBodyClass(name)) {
      sdk.utils.addBodyClass(name);
    }
  });
}

export function removeBodyClass(name: string) {
  getSdk().then((sdk) => {
    if (sdk.utils.hasBodyClass(name)) {
      sdk.utils.removeBodyClass(name);
    }
  });
}

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function waitForMetrics(): Promise<any | undefined> {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new Promise<any | undefined>(async (resolve: (value: any) => void) => {
    getSdk().then((sdk) => {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      let metrics: any | undefined;

      if (metrics) {
        resolve(metrics);

        return;
      }

      const waitInterval = window.setInterval(async () => {
        metrics = await sdk.game.getMetrics();

        if (!metrics) {
          return;
        }

        if (waitInterval) {
          clearInterval(waitInterval);
        }

        resolve(metrics);
      }, 500);
    });
  });
}
